import { TelemetryContext } from './telemetry-context';
import { DateUtility } from '../../date.utility';

export abstract class TelemetryEvent {
	public context: TelemetryContext = { };
	public readonly timestamp?: string;

	constructor(public name: string) {
		this.timestamp = DateUtility.now();
	}
}
